(function () {
  const accordions = () => {
    document.querySelectorAll('[data-amure-about-accordion]').forEach((list) => {
      list.querySelectorAll('.amure-about-accordion__button').forEach((btn) => {
        if (btn.dataset.amureBound === 'true') return;
        btn.dataset.amureBound = 'true';

        btn.addEventListener('click', () => {
          const item = btn.closest('.amure-about-accordion__item');
          if (!item) return;
          const open = item.classList.contains('is-open');

          list.querySelectorAll('.amure-about-accordion__item.is-open').forEach((el) => {
            el.classList.remove('is-open');
            const q = el.querySelector('.amure-about-accordion__button');
            if (q) q.setAttribute('aria-expanded', 'false');
          });

          if (!open) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  };

  const init = () => {
    accordions();
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
